import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerQuillPasteSanitizer } from './app/services/other/quill-paste-sanitizer';

registerQuillPasteSanitizer();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
